import React from 'react'

// Material UI
import { KeyboardDatePicker } from "@material-ui/pickers"
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es"
import { ThemeProvider } from "@material-ui/styles"
import { createMuiTheme } from "@material-ui/core"

// Libs
import classnames from 'classnames'

// Components
import Error from './error'

// Styles
import componentStyles from "./date-picker.module.css"

const PedroDatePicker = ({ placeholder, selectedDate, onChange, errors }) => {

    const theme = createMuiTheme({
        palette: {
            primary: { 500: "#46A0DE" },
        },
        spacing: 5
    })

    const classes = classnames(componentStyles.datepicker, { "error": errors && errors.length })

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale} >
            <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                    InputProps={{ disableUnderline: true }}
                    disableFuture={true}
                    invalidDateMessage={"Introduzca una fecha válida"}
                    inputProps={{ className: classes }}
                    InputAdornmentProps={{ style: { "display": "none" } }}
                    maskChar="_"
                    className="w-full mb-0"
                    placeholder={placeholder}
                    value={selectedDate ? selectedDate : null}
                    onChange={date => onChange(date)}
                    format="dd/MM/yyyy"
                />
                {errors && (
                    errors.map((e, i) => <Error key={i} index={i} message={e} />))}
            </ThemeProvider>
        </MuiPickersUtilsProvider >
    )
}

export default PedroDatePicker